<template lang="pug">
.activities-loading.row(data-testid="activities-loading")
  .activities-wrapper.col-xs-12
    .hour
      .row.details
        .col-xs-12
          .rounded-checkbox-wrapper.checkbox-md.select-row-wrapper
            input.rounded-checkbox
            label
      .row.row-activity
        .col-xs-12
          .row
            .col-lg-2.col-md-3.col-sm-4.col-xs-6.margin-bottom-xs(
              v-for="n in 6"
              :key="n"
            )
              .activity-screenshot
                .label-project-name
                  span PROJECT NAME
                .task-name.text-superlight &nbsp;
                .top-shot-body
                  .shot-body.fs-exclude
                    .screenshot-activity-overlay
                    .state_shot.no_screenshot
                      .state-shot-wrapper
                  .meta
                    .meta-head
                      .meta-interval &nbsp;
                    .row
                      .activity.col-xs-12
                        .progress
</template>

<script>
export default {};
</script>
